<template>
  <div>
    <component :is="GuestTopBar" />

    <component :is="CheckoutNavigation" />
  </div>
</template>

<script setup lang="ts">
import { defineComponent, h, ref } from 'vue'
import AppNavHeader from '~/components/AppNavHeader.vue'
import GuestTopBar from '~/components/GuestTopBar.vue'
import MobileNavDrawer from '~/components/MobileNavDrawer.vue'

const mobileMenuOpen = ref(false)

const closeMobileMenu = () => {
  mobileMenuOpen.value = false
}

const openMobileMenu = () => {
  mobileMenuOpen.value = true
}

const CheckoutNavigation = defineComponent({
  setup() {
    return () =>
      h(
        AppNavHeader,
        {
          onOpenMobileMenu: openMobileMenu,
          variant: 'checkout'
        },
        {
          bottom: () =>
            h(MobileNavDrawer, {
              onClose: closeMobileMenu,
              open: mobileMenuOpen.value
            })
        }
      )
  }
})
</script>
